import { Reveal } from "./Reveal";
import { ShieldCheck, MessageCircle, Scale } from "lucide-react";

const pillars = [
  {
    icon: ShieldCheck,
    title: "Twenty years of trust",
    body: "Two decades placing stamps in the right collections — no pressure, no gimmicks.",
  },
  {
    icon: Scale,
    title: "Fair, honest pricing",
    body: "Most items priced 20% under Scott Catalogue Value. We're not here to sell the expensive stamps — we're here to help you build.",
  },
  {
    icon: MessageCircle,
    title: "Fast email replies",
    body: "Voice mail can be spotty — email is the surest way to reach us and we answer quickly.",
  },
];

export function About() {
  return (
    <section id="about" className="relative border-y border-border/70 py-24 md:py-32" style={{ background: "var(--gradient-parchment)" }}>
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid gap-14 lg:grid-cols-[1fr_1.2fr] lg:items-start">
          <div>
            <Reveal>
              <p className="mb-4 text-xs uppercase tracking-[0.28em] text-accent">
                About Carolina Mountain Stamps
              </p>
            </Reveal>
            <Reveal delay={1}>
              <h2 className="font-display text-4xl leading-tight text-primary md:text-5xl">
                A quiet shop for the patient collector.
              </h2>
            </Reveal>
            <Reveal delay={2}>
              <p className="mt-6 text-lg text-foreground">
                Carolina Mountain Stamps has been serving collectors from
                Hendersonville, North Carolina for more than twenty years. We
                specialize in United States and worldwide postage stamps,
                covers, and supplies — the everyday pieces that turn an album
                into a lifetime pursuit.
              </p>
            </Reveal>
            <Reveal delay={3}>
              <p className="mt-4 text-muted-foreground">
                You'll find us inside the Needful Things Mall on Route 64 and
                on eBay — the same care, whichever door you walk through.
              </p>
            </Reveal>
          </div>

          <div className="grid gap-4 sm:grid-cols-2">
            {pillars.map((p, i) => (
              <Reveal key={p.title} delay={i}>
                <div className="h-full border border-border bg-card p-6 shadow-[var(--shadow-stamp)]">
                  <div className="mb-4 inline-flex h-10 w-10 items-center justify-center rounded-sm bg-primary/10 text-primary">
                    <p.icon className="h-5 w-5" aria-hidden="true" />
                  </div>
                  <h3 className="font-display text-xl text-primary">{p.title}</h3>
                  <p className="mt-2 text-sm text-muted-foreground">{p.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}